export default __webpack_public_path__ + "testimonial-tenant-30cbcc728b32547df28713d1be50258d.bundle.jpg";